import { HiChevronDoubleLeft, HiChevronDoubleRight } from 'react-icons/hi';
import Wrapper    from '../../assets/wrappers/PageBtnContainer';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAllSchedulesContext }   from '../../pages/AllCampaignSchedules';

const SchedulePaginationContainer = () => {
  const { data: { numOfPages, currentPage } } = useAllSchedulesContext();
  const pages = Array.from({ length: numOfPages }, (_, i) => i + 1);
  const { search, pathname } = useLocation();
  const navigate = useNavigate();

  const changePage = (page) => {
    const sp = new URLSearchParams(search);
    sp.set('page', page);
    navigate(`${pathname}?${sp.toString()}`);
  };

  return (
    <Wrapper>
      <button
        className='btn next-btn'
        onClick={() => changePage(currentPage === numOfPages ? 1 : currentPage + 1)}
      >
        הבא <HiChevronDoubleRight />
      </button>

      <div className='btn-container'>
        {pages.map((num) => (
          <button
            key={num}
            className={`btn page-btn ${num === currentPage ? 'active' : ''}`}
            onClick={() => changePage(num)}
          >
            {num}
          </button>
        ))}
      </div>

      <button
        className='btn prev-btn'
        onClick={() => changePage(currentPage === 1 ? numOfPages : currentPage - 1)}
      >
        <HiChevronDoubleLeft /> הקודם
      </button>
    </Wrapper>
  );
};

export default SchedulePaginationContainer;
